import { Button, Icon } from '@octano/global-ui';
import { FunctionComponent } from 'react';

type TeacherRowActionsProps = {
  children: React.ReactNode;
  isOnline?: boolean;
  isPresential?: boolean;
  childrenPrefix?: string;
  actionsPrefix?: string;
  onPressOnline?: () => void;
  onPressPresential?: () => void;
  onPressDelete?: () => void;
};

const TeacherRowActions: FunctionComponent<TeacherRowActionsProps> = ({
  children,
  isOnline = false,
  isPresential = false,
  childrenPrefix,
  actionsPrefix,
  onPressOnline,
  onPressPresential,
  onPressDelete,
}) => {
  return (
    <div className="d-flex">
      <div className="flex-grow-1 pr-3">
        {!!childrenPrefix && (
          <span className="uppercase">{childrenPrefix}</span>
        )}
        {children}
      </div>
      <div>
        {!!actionsPrefix && (
          <span
            className="w-100 text-center d-block uppercase"
            style={{ paddingRight: 50 }}
          >
            {actionsPrefix}
          </span>
        )}
        <div
          className="d-flex align-items-center justify-content-center pb-3"
          style={{ gap: 5 }}
        >
          <div>
            <Button
              text="P"
              style={{
                width: 65,
                backgroundColor:
                  isPresential && onPressPresential ? '#CEF0DA' : undefined,
              }}
              outlined
              disabled={!onPressPresential}
              onClick={onPressPresential}
            />
            <Button
              text="O"
              style={{
                width: 65,
                backgroundColor:
                  isOnline && onPressOnline ? '#CEF0DA' : undefined,
              }}
              outlined
              disabled={!onPressOnline}
              onClick={onPressOnline}
            />
          </div>
          <button
            type="button"
            className="btn d-flex align-items-center justify-content-center"
            style={{
              width: 45,
              height: 45,
            }}
            disabled={!onPressDelete}
            onClick={onPressDelete}
          >
            <Icon name="trash" color={onPressDelete ? 'primary' : 'disabled'} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeacherRowActions;
